import { useMediaQuery } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';

import { getMatchSSR } from '../breakpoint';
import { useDevice } from '../contexts/device-context';

export const useBreakpoint = (query: string): boolean => {
  const device = useDevice();
  const matchSSR = getMatchSSR(query, device);
  return useMediaQuery(query, matchSSR);
};
